<template>
  <template v-if="newQuestionsEnabled">
    <template v-if="!showQuestionForm">
      <button class="btn btn-primary" @click="openQuestionForm">
        {{ domainStore.translate('askus.create.title') }}
      </button>
      <OverlayPanel ref="loginOP" :showCloseIcon="true" :dismissable="true" appendTo="body" class="wdw-widgets">
        <Login :domainid="domainid" />
      </OverlayPanel>
    </template>
    <div v-else class="question-box">
      <QuestionForm @closeForm="closeQuestionForm" @openQuestion="openQuestion"></QuestionForm>
      <div class="question-box-seperator"></div>
    </div>
    <Message
      v-if="feedbackMessage.message !== ''"
      closable
      class="mb-2"
      role="alert"
      :severity="feedbackMessage.type || 'info'"
    >
      {{ feedbackMessage.message }}
    </Message>
  </template>
</template>

<script>
import { defineComponent, ref, computed, reactive } from 'vue';
import QuestionForm from '@/components/askus/QuestionForm.vue';
import Login from '@/components/user/Login.vue';
import OverlayPanel from 'primevue/overlaypanel';
import Message from 'primevue/message';
import { askusStore } from '@/store/askus-store';
import { domainStore } from '@/store/domain-store';
import { userStore } from '@/store/user-store';
import { IAskusQuestion } from '@/models/askus.model';

export default defineComponent({
  name: 'Askus',
  props: {},
  components: {
    QuestionForm,
    OverlayPanel,
    Login,
    Message,
  },
  emits: ['openQuestion'],

  setup(props, context) {
    const loginOP = ref();
    const showQuestionForm = ref(false);
    const feedbackMessage = reactive({
      message: '',
      type: '',
    });

    const askus = computed(() => {
      return askusStore.getState().askus;
    });
    const domainid = computed(() => {
      return domainStore.getState().domainid;
    });
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });
    const newQuestionsEnabled = computed(() => {
      return askus.value.new_questions;
    });
    const canAskQuestion = computed(() => {
      if (!newQuestionsEnabled.value) {
        return false;
      }
      if (askus.value.anon_questions) {
        return true;
      } else {
        return isLoggedIn.value;
      }
    });

    function toggleLogin(event) {
      loginOP.value.show(event);
    }
    function openQuestion(question, questionid) {
      context.emit('openQuestion', question, questionid);
    }
    function closeQuestionForm(data) {
      showQuestionForm.value = false;
      if (data && data.showSuccess) {
        feedbackMessage.message = domainStore.translate('askus.create.message.success');
        feedbackMessage.type = 'success';
        askusStore.fetchQuestions();
      } else {
        feedbackMessage.message = '';
        feedbackMessage.type = '';
      }
    }
    function openQuestionForm(event) {
      if (canAskQuestion.value) {
        showQuestionForm.value = true;
      } else if (newQuestionsEnabled.value) {
        toggleLogin(event);
      }
    }

    return {
      domainStore,
      askus,
      domainid,
      isLoggedIn,
      loginOP,
      newQuestionsEnabled,
      showQuestionForm,
      feedbackMessage,
      openQuestion,
      closeQuestionForm,
      openQuestionForm,
    };
  },
});
</script>

<style scoped>
.question-box {
  margin-bottom: 25px;
}
.question-box-seperator {
  display: block;
  width: 100%;
  height: 15px;
  border-bottom: solid 2px #000;
}
</style>
